export const iconFontAwesomeEducationSchoolCircleCheck = (
	<i className="fa-solid fa-school-circle-check"></i>
);
